import { ChipSelect, ChipSelectInline } from "./ChipSelect";
import { Home, Users, Briefcase, User } from "lucide-react";

const CLIENT_TYPE_OPTIONS = [
  { value: "vendor", label: "Vendor", icon: Home },
  { value: "buyer", label: "Buyer", icon: Users },
  { value: "landlord", label: "Landlord", icon: Briefcase },
  { value: "tenant", label: "Tenant", icon: User },
];

const CONDITION_OPTIONS = [
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "needs_work", label: "Needs Work" },
];

const BUDGET_OPTIONS = [
  { value: "none", label: "N/A" },
  { value: "under_20k", label: "<£20k" },
  { value: "20k_to_50k", label: "£20-50k" },
  { value: "over_50k", label: "£50k+" },
];

const GOAL_OPTIONS = [
  { value: "sell", label: "Prepare to Sell" },
  { value: "rent", label: "Optimise Rental" },
  { value: "add_space", label: "Add Space" },
  { value: "boost_value", label: "Boost Value" },
];

export function AssessmentContextScreen({ data, onChange }) {
  const updateField = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Client Relationship */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Client Relationship
        </label>
        <ChipSelect
          options={CLIENT_TYPE_OPTIONS}
          value={data.client_type}
          onChange={(v) => updateField("client_type", v)}
          columns={2}
        />
      </div>

      {/* Property Condition */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Property Condition
        </label>
        <ChipSelectInline
          options={CONDITION_OPTIONS}
          value={data.condition}
          onChange={(v) => updateField("condition", v)}
        />
      </div>

      {/* Client Budget */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Client Budget
        </label>
        <ChipSelectInline
          options={BUDGET_OPTIONS}
          value={data.budget}
          onChange={(v) => updateField("budget", v)}
        />
      </div>

      {/* Client Goal */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Client's Goal
        </label>
        <ChipSelect
          options={GOAL_OPTIONS}
          value={data.main_goal}
          onChange={(v) => updateField("main_goal", v)}
          columns={2}
        />
      </div>

      {/* Notes */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Notes <span className="text-white/30 font-normal">(optional)</span>
        </label>
        <textarea
          value={data.notes || ""}
          onChange={(e) => updateField("notes", e.target.value)}
          placeholder="Any additional context for this assessment..."
          className="w-full bg-white/5 border border-white/10 rounded-xl p-3 text-sm text-white placeholder:text-white/30 resize-none h-20 focus:outline-none focus:border-cipher-green/40 transition-colors"
          data-testid="express-notes"
        />
      </div>
    </div>
  );
}

export function isAssessmentContextComplete(data) {
  return (
    data.client_type &&
    data.condition &&
    data.budget &&
    data.main_goal
  );
}
